import { Divider } from "primereact/divider";
import React from "react";

const TransactionCard = ({
  currencyType,
  data,
  totalAmt,
  totalTransactions,
  totalSuccessTrans,
  totalFailedTrans,
  forOverstay = false,
  totalDuplicates,
  totalRefund,
  totalGrossSales,
}) => {
  // Determine if currency is PHP (for ₱ symbol)
  const isPhp = currencyType === "PHP";

  const formatValue = (value) => {
    const number = parseFloat(value);
    if (isNaN(number)) return value;

    const formatted = number.toLocaleString("en-PH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return isPhp ? `₱${formatted}` : formatted;
  };

  return (
    <>
      {!forOverstay && (
        <div className="border border-black h-auto p-2 text-center w-full">
          <div className="flex flex-col justify-between">
            <div className="text-lg font-bold">{currencyType}</div>

            {/* Successful Transaction Section */}
            <div className="grid grid-cols-2 w-full items-center font-semibold">
              <div className="col-span-1 items-start text-start grid">
                Successful Transaction:
              </div>
              <div className="col-span-1 text-green-400 items-end grid text-end pr-3">
                {formatValue(
                  totalSuccessTrans.subtotal[isPhp ? "php" : "coins"]
                )}
              </div>

              <div className="ml-4 text-[15px] text-left font-normal col-span-2">
                <div className="flex justify-between w-full">
                  Storage Service:
                  <div className="text-green-400 items-end grid text-end pr-3">
                    {formatValue(
                      totalSuccessTrans.storage[isPhp ? "php" : "coins"]
                    )}
                  </div>
                </div>

                <div className="flex justify-between w-full">
                  Drop-off Service:
                  <div className="text-green-400 items-end grid text-end pr-3">
                    {formatValue(
                      totalSuccessTrans.dropOff[isPhp ? "php" : "coins"]
                    )}
                  </div>
                </div>
              </div>

              {/* <div className="col-span-2">
            <Divider className="border border-gray-200"></Divider>
          </div> */}
            </div>

            {/* Failed Transaction Section */}
            <div className="grid grid-cols-2 w-full items-center font-semibold pt-2">
              <div className="col-span-1 items-start text-start grid">
                Failed Transaction:
              </div>
              <div className="col-span-1 text-red-400 items-end grid text-end pr-3">
                {formatValue(
                  totalFailedTrans.subtotal[isPhp ? "php" : "coins"]
                )}
              </div>

              <div className="ml-4 text-[15px] text-left font-normal col-span-2">
                <div className="flex justify-between w-full">
                  Storage Service:
                  <div className="text-red-400 items-end grid text-end pr-3">
                    {formatValue(
                      totalFailedTrans.storage[isPhp ? "php" : "coins"]
                    )}
                  </div>
                </div>

                <div className="flex justify-between w-full">
                  Drop-off Service:
                  <div className="text-red-400 items-end grid text-end pr-3">
                    {formatValue(
                      totalFailedTrans.dropOff[isPhp ? "php" : "coins"]
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="border border-gray-200 my-2"></div>

            {/* Totals Section */}
            <div className="grid grid-cols-2 w-full items-center font-bold text-lg">
              <div className="col-span-1 items-start text-start grid">
                Total Amount:
              </div>
              <div className="col-span-1 items-end grid text-end pr-3">
                {formatValue(totalAmt[isPhp ? "php" : "coins"])}
              </div>
            </div>

            <div className="grid grid-cols-2 w-full items-center font-medium text-sm text-gray-600">
              <div className="col-span-1 items-start text-start grid">
                Total Transactions:
              </div>
              <div className="col-span-1 items-end grid text-end pr-3">
                {totalTransactions[isPhp ? "php" : "coins"]}
              </div>
            </div>
          </div>
        </div>
      )}

      {forOverstay && (
        <>
          <div className="border border-black text-black h-auto py-2 text-center w-full">
            <div className="flex flex-col justify-between">
              <div className="text-lg font-bold">{currencyType}</div>
              {/* Successful Transaction Section */}
              <div className="grid grid-cols-6 w-full items-center font-semibold">
                <div className="col-span-6 items-center px-2">
                  <div className="grid grid-cols-6 w-full items-center font-semibold">
                    <div className="col-span-4 text-start grid">
                      Recorded Successful Transactions
                    </div>

                    <div className="col-span-2 text-green-600 items-end grid text-end pr-3">
                      {formatValue(
                        totalSuccessTrans.subtotal[isPhp ? "php" : "coins"]
                      )}
                    </div>

                    <div className="col-span-6 ml-4 text-[15px] text-left font-normal">
                      Successful Transactions
                    </div>
                    <div className="ml-8 text-[15px] text-left font-light col-span-6">
                      <div className="flex justify-between w-full">
                        Storage Service:
                        <div className="text-green-600 items-end grid text-end pr-3">
                          {formatValue(
                            totalSuccessTrans.storage[isPhp ? "php" : "coins"]
                          )}
                        </div>
                      </div>

                      <div className="flex justify-between w-full">
                        Drop-off Service:
                        <div className="text-green-600 items-end grid text-end pr-3">
                          {formatValue(
                            totalSuccessTrans.dropOff[isPhp ? "php" : "coins"]
                          )}
                        </div>
                      </div>
                    </div>

                    {/* ---------------------------- */}
                    {forOverstay && (
                      <>
                        <div className="col-span-6 ml-4 text-[15px] text-left font-normal">
                          Duplicate Transactions
                        </div>
                        <div className="ml-8 text-[15px] text-left font-light col-span-6">
                          <div className="flex justify-between w-full">
                            Storage Service:
                            <div className="text-green-600 items-end grid text-end pr-3">
                              {formatValue(
                                totalDuplicates.storage[isPhp ? "php" : "coins"]
                              )}
                            </div>
                          </div>

                          <div className="flex justify-between w-full">
                            Drop-off Service:
                            <div className="text-green-600 items-end grid text-end pr-3">
                              {formatValue(
                                totalDuplicates.dropOff[isPhp ? "php" : "coins"]
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* {isPhp && ( */}
                <>
                  <div className="border border-gray-200 col-span-6 "></div>
                  <div className=" col-span-6 items-center px-2 pt-1">
                    <div className="grid grid-cols-6 w-full items-center font-semibold">
                      <div className="col-span-4 items-start text-start grid">
                        (LESS) Refunded Transactions
                      </div>
                      {/* <div className="col-span-1 font-normal text-right">
                      Total:
                    </div> */}
                      <div className="col-span-2 text-orange-400 items-end grid text-end pr-3">
                        {formatValue(
                          totalRefund.subtotal[isPhp ? "php" : "coins"]
                        )}
                      </div>

                      <div className="ml-8 text-[15px] text-left font-light col-span-6">
                        <div className="flex justify-between w-full">
                          Storage Service:
                          <div className="text-orange-400 items-end grid text-end pr-3">
                            {formatValue(
                              totalRefund.storage[isPhp ? "php" : "coins"]
                            )}
                          </div>
                        </div>

                        <div className="flex justify-between w-full">
                          Drop-off Service:
                          <div className="text-orange-400 items-end grid text-end pr-3">
                            {formatValue(
                              totalRefund.dropOff[isPhp ? "php" : "coins"]
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
                {/* )} */}

                <div className="border border-gray-200 col-span-6"></div>
                <div className="text-2xl px-3 bg-primary-primaryYellowLight col-span-6 py-2">
                  <div className="grid grid-cols-5 items-center">
                    <div className="uppercase font-bold col-span-3 text-left">
                      Gross Sales:
                    </div>
                    <div className="uppercase font-bold tracking-wide col-span-2 text-right">
                      {formatValue(totalGrossSales[isPhp ? "php" : "coins"])}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="border border-black border-t-0 text-black h-auto p-2 text-center w-full bg-gray-100">
            {/* Failed Transaction Section */}
            <div className="grid grid-cols-6  w-full items-center font-semibold">
              <div className="col-span-4 items-start text-start grid">
                Recorded Failed Transactions
              </div>
              {/* <div className="col-span-1 font-normal text-right">Total:</div> */}
              <div className="col-span-2 text-red-400 items-end grid text-end pr-3">
                {formatValue(
                  totalFailedTrans.subtotal[isPhp ? "php" : "coins"]
                )}
              </div>

              <div className="ml-8 text-[15px] text-left font-normal col-span-6">
                <div className="flex justify-between w-full">
                  Storage Service:
                  <div className="text-red-400 items-end grid text-end pr-3">
                    {formatValue(
                      totalFailedTrans.storage[isPhp ? "php" : "coins"]
                    )}
                  </div>
                </div>

                <div className="flex justify-between w-full">
                  Drop-off Service:
                  <div className="text-red-400 items-end grid text-end pr-3">
                    {formatValue(
                      totalFailedTrans.dropOff[isPhp ? "php" : "coins"]
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TransactionCard;
